import { State } from "core";
import { RemoteNotification, UserProfile } from "@blacknut/javascript-sdk/dist";

import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import dimens from "src/theme/dimens";
import { ReactComponent as AvatarDefault } from "../../assets/dist/ic_account_default.svg";
import useAnonymousCheck from "../../utils/useAnonymousCheck";
import AvatarImage from "../AvatarSelectionModal/AvatarImage";
import NavLink from "../NavLink";
import styles from "./styles.module.scss";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { useLocation } from "react-router-dom-v5-compat";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

export const unreadNotificationsSelector = createSelector(
  (state: State) => state.globalState.remoteNotifications,
  (remoteNotifications: RemoteNotification[]) => {
    return remoteNotifications.filter((notif) => notif.isNew).length;
  },
);

interface AccountIconProps {
  activeItem: string;
  profile: UserProfile;
  expanded: boolean;
}
const AccountIcon = ({ activeItem, profile, expanded }: AccountIconProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { navigate } = useAppNavigation();
  const unreadNotificationsLen = useSelector(unreadNotificationsSelector);
  const { checkForAnonymous } = useAnonymousCheck();
  const onClick = useCallback(
    (e: React.UIEvent<unknown>) => {
      e.preventDefault();
      if (checkForAnonymous()) {
        navigate(
          window?.innerWidth < dimens.breakpoints.desktop
            ? "/account/me"
            : "/account/profiles/switch",
        );
      }
    },
    [checkForAnonymous, navigate],
  );
  return (
    <NavLink
      data-testid="account"
      to={"/account/me"}
      replace={pathname === "/account/me"}
      isActive={() => activeItem === "account"}
      activeClassName={styles.active}
      className={styles.focusable}
      onClick={onClick}
      linkClassName={styles.link}
    >
      {profile.avatarId && <AvatarImage avatarId={profile.avatarId} />}

      {!profile.avatarId && <AvatarDefault className="svg" />}

      {unreadNotificationsLen > 0 && (
        <div className={styles.newBadge} data-testid="badge" />
      )}

      <span className={clsx(styles.label, !expanded && styles.hidden)}>
        {t("menu.profile")}
      </span>
    </NavLink>
  );
};

export default AccountIcon;
